module.exports = __webpack_public_path__ + "img/Inflammation-CRC_10X_WTA.c249e165.png";